// The set the Dancing Fruit Yogurt play at the café. One song = a beatmap the
// rhythm engine renders as falling notes AND the note list the groove synth
// plays as its lead line, so hitting a note in time literally plays the melody.
//
// Grid: 4/4 at BPM below, one bar = 4 beats = 8 eighth-note steps. Patterns are
// 8-long arrays of a lane index (0-3) or -1 for a rest. Lane pitches are an
// A-minor pentatonic (no wrong notes however you hit), rising left→right.

const BPM = 96;
const SEC_PER_BEAT = 60 / BPM;          // 0.625s
const EIGHTH = SEC_PER_BEAT / 2;        // 0.3125s
const COUNT_IN = 4 * SEC_PER_BEAT;      // one bar of groove before the first note (2.5s)

// lane → frequency (Hz): A3, C4, E4, G4  (A minor pentatonic)
const LANE_PITCHES = [220.00, 261.63, 329.63, 392.00];
// one bass root per bar, cycling (Am – F – C – G feel): A2, F2, C3, G2
const BASS_ROOTS = [110.00, 87.31, 130.81, 98.00];

// eighth-note patterns (lane per step, -1 = rest)
const P = {
  a:    [ 0, -1,  2, -1,  1, -1,  3, -1],
  b:    [ 0, -1,  1,  2,  3, -1,  2, -1],
  c:    [ 3, -1,  2, -1,  1, -1,  0, -1],
  climb:[ 0,  1,  2,  3,  2,  1,  0, -1],
  sync: [ 0, -1, -1,  2, -1,  1, -1,  3],
  fill: [ 0,  1,  2,  3,  0,  1,  2,  3]
};

// 16-bar arrangement: eases in, builds to a couple of fills.
const ARRANGEMENT = ['a','a','b','a', 'c','a','b','sync', 'a','sync','b','climb', 'c','climb','fill','fill'];

export function buildSong(){
  const notes = [];
  ARRANGEMENT.forEach((key, bar) => {
    const pat = P[key];
    for (let i = 0; i < pat.length; i++){
      const lane = pat[i];
      if (lane < 0) continue;
      const step = bar * 8 + i;                 // global eighth-note index
      notes.push({ time: COUNT_IN + step * EIGHTH, lane });
    }
  });

  const lastNote = notes.length ? notes[notes.length - 1].time : COUNT_IN;
  return {
    bpm: BPM,
    secPerBeat: SEC_PER_BEAT,
    eighth: EIGHTH,
    countIn: COUNT_IN,
    lanePitches: LANE_PITCHES,
    bassRoots: BASS_ROOTS,
    notes,
    lastNote,
    duration: lastNote + 2.0        // short tail so the last note can be hit
  };
}
